<template>
  <div class="staff_member">
    <div class="profile">
      <picture>
        <source :srcset="profileImg"
                  media="(min-width: 768px)">
        <source :srcset="profileImgSp"
                  media="(max-width: 767px)">
          <img :src="profileImg" :alt="profileAlt" />
      </picture>
    </div>

    <div class="contents">
      <section class="faq_contents">
        <StaffFaqLine :image="require('../../assets/img/gen/staff/q1.svg')" alt="q1" question="学生時代に<br>取り組んだことは？" :answer="answer01" />

        <StaffFaqLine :image="require('../../assets/img/gen/staff/q2.svg')" alt="q2" question="クレハに入社した<br>“決め手”は？" :answer="answer02" />
        
        <StaffFaqLine :image="require('../../assets/img/gen/staff/q3.svg')" alt="q3" question="現在の仕事内容は？" :answer="answer03" />


        <div class="image_cut">
          <picture>
            <source :srcset="imageCut01"
                      media="(min-width: 768px)">
            <source :srcset="imageCut01Sp"
                      media="(max-width: 767px)">
              
            <img :src="imageCut01" alt="schedule">
          </picture>
        </div>
        
        <StaffFaqLine :image="require('../../assets/img/gen/staff/q4.svg')" alt="q4" question="
        これまでの仕事で<br>特に印象に残っている<br>エピソードは？" :answer="answer04" />

        <StaffFaqLine :image="require('../../assets/img/gen/staff/q5.svg')" alt="q5" question="今後、クレハで<br>実現したいこと、<br>挑戦したいことは？" :answer="answer05" />
        <StaffFaqLine :image="require('../../assets/img/gen/staff/q6.svg')" alt="q6" question="ズバリ、クレハの<br>イイところは？" :answer="answer06" />

        <div class="image_cut">
          <picture>
            <source :srcset="imageCut02"
                      media="(min-width: 768px)">
            <source :srcset="imageCut02Sp"
                      media="(max-width: 767px)">
              
            <img :src="imageCut02" alt="schedule">
          </picture>
        </div>

        <div class="schedule">
          <picture>
            <source :srcset="schedule"
                      media="(min-width: 768px)">
            <source :srcset="scheduleSp"
                      media="(max-width: 767px)">
              
            <img :src="schedule" alt="schedule">
          </picture>
        </div>

      </section>

      <StaffLink />

    </div>
  </div>
</template>

<script>
import StaffFaqLine from "@/components/gen/StaffFaqLine.vue";
import StaffLink from "@/components/gen/StaffLink.vue";
export default {
  name: 'staff_contents',
  components: {
    StaffFaqLine,
    StaffLink
  },
  props: {
    profileImg: {
      type: String,
      default: "",
    },
    profileImgSp: {
      type: String,
      default: "",
    },
    profileAlt: {
      type: String,
      default: "",
    },
    answer01: {
      type: String,
      default: "",
    },
    answer02: {
      type: String,
      default: "",
    },
    answer03: {
      type: String,
      default: "",
    },
    answer04: {
      type: String,
      default: "",
    },
    answer05: {
      type: String,
      default: "",
    },
    answer06: {
      type: String,
      default: "",
    },
    imageCut01: {
      type: String,
      default: "",
    },
    imageCut02: {
      type: String,
      default: "",
    },
    imageCut01Sp: {
      type: String,
      default: "",
    },
    imageCut02Sp: {
      type: String,
      default: "",
    },
    schedule: {
      type: String,
      default: "",
    },
    scheduleSp: {
      type: String,
      default: "",
    }
  }
}
</script>
<style lang="scss" scoped>
.staff_member {
  padding: 100px 0;
  @media print,screen and (max-width: 767px) {
    padding: 0 0 50px 0;   
  }
}
.profile {
  margin: 0 auto;
  margin-top: 100px;
  @media print,screen and (min-width: 768px) {
    max-width: 1000px;
  }
}
.contents {
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
}
.image_cut,.schedule {
  margin-top: 100px;
  @media print,screen and (max-width: 767px) {
    margin-top: 50px; 
  }
  img {
    width: 100%;
  }
}
</style>